import React from "react";
import { StepHeader } from "./components/StepHeader";
import { FullscreenModal } from "./components/FullscreenModal";
import { useSteps } from "./useSteps";
import { useWarehouseContext } from "./WarehouseProvider";
import returnToSellerIcon from "./assets/return-to-seller-icon.png";
import { Summary } from "./Summary";
import {
  WarehouseButtonsFooter,
  WarehouseButton,
  WarehouseButtonGroup,
} from "./components/WarehouseButtonsFooter";

const TITLE = "Return to Seller";

export const ReturnToSellerInfo = () => {
  const { updateTakeback, clearTakeback, currentTakeback } =
    useWarehouseContext();
  const { exit, props, jumpTo } = useSteps();
  const { selectedOption, description } = props || {};

  // Get customer data from the takeback
  const takebackData =
    typeof currentTakeback?.data === "object"
      ? currentTakeback?.data
      : JSON.parse(currentTakeback?.data || "{}");

  // Extract customer info
  const customerName =
    `${currentTakeback?.customer_id_belongsTo?.name || ""} ${currentTakeback?.customer_id_belongsTo?.last_name || ""}`.trim() ||
    "Seller";
  const address = takebackData?.address || {};

  const onFinish = async () => {
    try {
      // Pass resolution data to updateTakeback
      updateTakeback({
        resolutionCategory: selectedOption,
        resolutionReason: description,
      });
      clearTakeback();
      exit({ successMessage: "Successfully processed package" });
    } catch (e) {
      console.error("Failed to process return:", e);
    }
  };

  const onBack = () => {
    jumpTo(Summary);
  };

  return (
    <FullscreenModal>
      <div className="flex flex-col h-full bg-[#030711]">
        <StepHeader />

        <div className="flex-1 flex flex-col items-center justify-center px-4">
          <div className="text-center max-w-2xl">
            {/* Return to seller icon */}
            <img
              src={returnToSellerIcon}
              alt="Return to seller"
              className="w-[168px] h-[168px] mx-auto mb-8"
            />

            <h1 className="text-white text-[32px] font-bold mb-2 leading-tight">
              Return to seller
            </h1>

            <p className="text-[#8B92AC] text-lg mb-12">
              Repackage and place in outbound zone.
            </p>

            <div className="bg-[#030711] rounded-2xl p-8 mb-8 max-w-3xl mx-auto min-w-[400px] text-center border-[#282F44] border-[1px]">
              <p className="font-bold text-white text-lg mb-3">Return to:</p>
              <div className="text-white space-y-1">
                <p className="text-base">Mr {customerName}</p>
                <p className="text-base">
                  {address.street1 || "2028 Shadwell Way"}
                </p>
                <p className="text-base">
                  {address.city || "Lawrenceville"}, {address.state || "GA"}{" "}
                  {address.zip || "30043"}
                </p>
                <p className="text-base">
                  {address.country || "United States"}
                </p>
              </div>
            </div>
          </div>
        </div>

        <WarehouseButtonsFooter>
          <WarehouseButtonGroup columns={3}>
            <WarehouseButton variant="default" onClick={onBack}>
              Back
            </WarehouseButton>
            <button
              className="w-full rounded-lg font-normal border-2 border-[#282F44] bg-transparent text-white py-3.5 m-0 hover:bg-[#282F44]/20 shadow-[0px_1px_2px_0px_rgba(0,0,0,0.08),inset_0px_-1px_1px_0px_rgba(0,0,0,0.16)] flex items-center justify-center gap-2"
              onClick={() =>
                window.open(
                  "https://intercom.help/legobricktakeback/en/articles/8738741-how-to-process-hazardous-takebacks",
                  "_blank"
                )
              }
            >
              View Guidance
              <svg
                width="17"
                height="17"
                viewBox="0 0 17 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="mt-0.5"
              >
                <path
                  d="M3.5 3.5V13.5H13.5V8.5H15V13.5C15 14.325 14.325 15 13.5 15H3.5C2.6675 15 2 14.325 2 13.5V3.5C2 2.675 2.6675 2 3.5 2H8.5V3.5H3.5ZM10.25 3.5V2H15V6.75H13.5V4.5575L7.2725 10.785L6.215 9.7275L12.4425 3.5H10.25Z"
                  fill="white"
                />
              </svg>
            </button>
            <WarehouseButton variant="primary" onClick={onFinish}>
              Ok, Done
            </WarehouseButton>
          </WarehouseButtonGroup>
        </WarehouseButtonsFooter>
      </div>
    </FullscreenModal>
  );
};

ReturnToSellerInfo.title = TITLE;
